export default __webpack_public_path__ + "static/media/ALIGN_CENTER_pressed.58819a8e.svg";